export default __webpack_public_path__ + "static/media/icon_reader_mobile_pause.01aae29e.svg";